import { GalleryItemProps } from '../ProGallery.types';

export const isEditingHover = (forceState: any) => {
  const { selectionSelector, stateAttribute } = forceState;

  return (
    selectionSelector === '.root::item' &&
    stateAttribute === 'stylable-force-state-hover'
  );
};

export const formatItemUri = (item: GalleryItemProps) => {
  const prefixUri = (uri: string): string => {
    if (uri.substr(0, 4) !== 'http') {
      return 'https://static.wixstatic.com/media/' + uri;
    } else {
      return uri;
    }
  };

  return {
    ...item,
    image: {
      ...item.image,
      uri: prefixUri(item.image.uri),
    },
  };
};
